import { createSelector } from 'reselect';
import { AppState } from '../../base/types';

const pdfReportURL = (state: AppState, id: string): { url: string } => state.app.pdf && state.app.pdf[id];
export const getPdfReportURLSelector = createSelector(
    [pdfReportURL],
    (url) => url,
);
